const translations = {
  cancel: 'Cancelar',
  save: 'Guardar',
  next: 'Siguiente',
  back: 'Volver',
  undo: 'Deshacer',
  search: 'Buscar',
  user: 'Usuario',
  place: 'Lugar',
  images: 'Imágenes',
  files: 'Archivos',
  notApplicable: 'N/A',
  removed: 'Eliminado',
  disabled: 'Desactivado',
  enabled: 'Activados',
  addNewOption: 'Agregar nueva opción',
  selectEmoji: 'Seleccionar emoji',
  optional: 'opcional',
  'emoji.smileysPeople': 'Emoticonos y Personas',
  'emoji.animalsNature': 'Animales y Naturaleza',
  'emoji.foodDrink': 'Comida y Bebidas',
  'emoji.travelPlaces': 'Viajes y Lugares',
  'emoji.activities': 'Actividades',
  'emoji.objects': 'Objetos',
  'emoji.symbols': 'Símbolos',
  complement: 'Complemento',
  complementOptional: 'Complemento (opcional)',
  hour: 'Hora',
  minute: 'Min.',
  errorLoadingGoogleMaps: 'Error al cargar Google Maps',
  'pdf.autoPageBreak': 'Ajuste automático de salto de página',
  'pdf.baseFontSize': 'Tamaño base de fuentes',
  'pdf.enableColors': 'Habilitar colores',
  'pdf.showImages': 'Mostrar imágenes',
  'pdf.showSignature': 'Mostrar firma',
  'pdf.imageHeight': 'Altura de imágenes',
  'pdf.itemsPerLine': 'Imágenes y archivos por línea',
  'pdf.options.realSize': 'Tamaño real',
  'pdf.options.size.verySmall': 'Muy pequeño',
  'pdf.options.size.small': 'Pequeño',
  'pdf.options.size.standard': 'Estándar',
  'pdf.options.size.medium': 'Mediano',
  'pdf.options.size.large': 'Grande',
  'pdf.options.size.veryLarge': 'Muy grande',
  'pdf.options.size.giant': 'Gigante',
  'pdf.options.sizeWithPx': '{{size}} ({{px}}px)',
  'pdf.options.sizeWithNumber': '{{size}} ({{value}})',
  'pdf.options.perLine': '{{count}} por línea',
  'pdf.download': 'Descargar {{extension}}',
  'pdf.imagesCount': '{{count}} imagen',
  'pdf.imagesCount_plural': '{{count}} imágenes',
  'pdf.filesCount': '{{count}} archivo',
  'pdf.filesCount_plural': '{{count}} archivos',
  'pdf.itemCount': '{{count}} ítem',
  'pdf.itemCount_plural': '{{count}} ítems',
  'pdf.notes': 'Notas',
  'pdf.photos': 'Fotos',
  'pdf.active': 'Activo',
  'pdf.inactive': 'Inactivo',
  'pdf.stock.item': 'Ítem',
  'pdf.stock.amount': 'Cantidad',
  'pdf.stock.operation': 'Operación',
  'pdf.stock.user': 'Usuario',
  'pdf.stock.place': 'Lugar',
  'filter.enabledDisabled': 'Activado/Desactivado',
  'filter.enabled': 'Activados',
  'filter.disabled': 'Desactivados',
  'filter.removed': 'Eliminados',
  'messages.mobileAccuracy': 'Para mayor precisión, responda a través de la aplicación.',
  clearAndInsertNewSignature: 'Limpiar e insertar nueva firma',
  clear: 'Limpiar',
  insertSignature: 'Insertar firma',
  document: 'Documento',
  includeSignatureInRectangle: 'Incluya su firma dentro del rectángulo',
  nameRequired: 'Nombre (obligatorio)',
  addSignature: 'Agregar firma',
  signaturePrefilledFromProfile: 'Firma rellenada con los datos de tu perfil. Puedes cambiarla si lo deseas.',
  updateLocation: 'Actualizar Ubicación',
  saveLocation: 'Guardar Ubicación',
  latitude: 'Latitud',
  longitude: 'Longitud',
  permissionDeniedInBrowser: 'Permiso denegado en el navegador',
  'processesMessage.backToPreviousVersion': 'Volver a la versión anterior',
  'processesMessage.activateNewVersion': 'Activar la nueva versión',
  'processesMessage.newFeatureActivated': '**¡Nueva funcionalidad activada!**',
  'processesMessage.discoverNewFeature': '**¡Conoce la nueva funcionalidad!**',
  'processesMessage.enjoyNewFeature': 'Disfruta la nueva funcionalidad para gestionar actividades por proceso.',
  'processesMessage.viewAndManageByProcess': 'Visualiza y gestiona actividades por proceso.',
  generalRegistrations: 'Registros generales',
  pendingTypes: 'Tipos de pendencias',
  approvalReasons: 'Motivos de aprobación',
  disapprovalReasons: 'Motivos de rechazo',
  unproductiveReasons: 'Motivos de improductividad',
  cancellationReasons: 'Motivos de cancelación',
  pauseReasons: 'Motivos de pausa',
  closingReasons: 'Motivos de cierre',
  userGroups: 'Grupos de usuarios',
  assetTypes: 'Tipos de activos',
  checklistCategories: 'Categorías de cuestionarios',
  levelsOf: 'Niveles de {{name}}'
}

export default translations
